import { components } from "shared/components/wrappers";
import type { App } from "vue";

export default {
  install: (app: App) => {
    components.forEach(({ name, component }) => {
      app.component(name, component);
    });
  },
};
